import { jsx as _jsx } from "react/jsx-runtime";
import { DarkMode, LightMode, useColorMode } from "../chakra/internal";
import React, { useEffect } from "react";
export { DarkMode, LightMode, useColorMode };
export const InverseMode = ({ children })=>{
    const { colorMode } = useColorMode();
    return colorMode === 'light' ? /*#__PURE__*/ _jsx(DarkMode, {
        children: children
    }) : /*#__PURE__*/ _jsx(LightMode, {
        children: children
    });
};
export const AppColorModeEnforcer = ({ colorMode })=>{
    const { colorMode: currentMode, setColorMode } = useColorMode();
    useEffect(()=>{
        if (currentMode !== colorMode) {
            setColorMode(colorMode);
        }
    }, [
        colorMode,
        currentMode,
        setColorMode
    ]);
    return null;
};

//# sourceMappingURL=index.js.map